import {
  ColumnMenu,
  ColumnOption
} from 'src/components/shared/DataGrid/ColumnMenu';
import { ProductDto } from 'src/store/products/product';
import { LocalStorage } from 'src/utils/localStorage';

export const PRODUCT_COLUMNS_KEY = 'product_columns';

const productColumns: ColumnOption<ProductDto>[] = [
  {
    title: 'product.runNo',
    field: 'runNo',
    disabled: true
  },
  {
    title: 'runSystem.singular',
    field: 'runSystemName',
    disabled: true
  },
  {
    title: 'product.runDate',
    field: 'runDate',
    disabled: true
  },
  {
    title: 'product.runText',
    field: 'runText'
  },
  {
    title: 'product.lotText',
    field: 'lotText'
  },
  {
    title: 'grade.singular',
    field: 'gradeName'
  },
  {
    title: 'productType.singular',
    field: 'productTypeName'
  },
  {
    title: 'segment.singular',
    field: 'segmentName'
  },
  {
    title: 'product.lotNo',
    field: 'lotNo'
  },
  {
    title: 'product.lotDate',
    field: 'lotDate'
  },
  {
    title: 'product.norlabNo',
    field: 'norlabNo'
  },
  {
    title: 'productStatus.singular',
    field: 'productStatusName'
  },
  {
    title: 'specification.pspNo',
    field: 'specificationNo'
  },
  {
    title: 'specification.psp',
    field: 'specificationName'
  },
  {
    title: 'product.mixture',
    field: 'mixtureNo'
  },
  {
    title: 'product.mixtures',
    field: 'mixtures'
  },
  {
    title: 'props.description',
    field: 'description'
  }
];

export const getProductColumns = (): ColumnOption<ProductDto>[] =>
  LocalStorage.getItem(PRODUCT_COLUMNS_KEY) ?? productColumns;

type ProductsListColumnMenuProps = {
  selectedColumns: ColumnOption<ProductDto>[];
  onSelectedColumnsChange: (columns: ColumnOption<ProductDto>[]) => void;
};

export function ProductsListColumnMenu({
  selectedColumns,
  onSelectedColumnsChange
}: ProductsListColumnMenuProps) {
  const onColumnsChange = (columns: ColumnOption<ProductDto>[]) => {
    onSelectedColumnsChange(columns);
    LocalStorage.setItem(PRODUCT_COLUMNS_KEY, columns);
  };

  return (
    <ColumnMenu
      columns={productColumns}
      selectedColumns={selectedColumns}
      onColumnsChange={onColumnsChange}
    />
  );
}
